module.exports = __webpack_public_path__ + "img/internal-notifications-selected.3508e240.svg";